import { render, staticRenderFns } from "./TableList.vue?vue&type=template&id=1ba0284e&scoped=true&"
import script from "./TableList.vue?vue&type=script&lang=js&"
export * from "./TableList.vue?vue&type=script&lang=js&"
import style0 from "./TableList.vue?vue&type=style&index=0&id=1ba0284e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ba0284e",
  null
  
)

export default component.exports